export default "__VITE_ASSET__00dddd67__"